










import { Vue, Component } from 'vue-property-decorator';
import HistoricoInformeData from '@/pantallas/HistoricoInforme/HistoricoInformeData.vue';

@Component({
  components: { HistoricoInformeData },
})
export default class HistoricoInforme extends Vue {}
